import css, { resolve } from 'styled-jsx/css';
import { screen } from 'components/styles/variables';

export default css`
  .review-container {
    margin: 0 0 32px 0;
    font-size: 16px;
  }

  .review {
    display: flex;
    flex-direction: column;
  }

  .layout-container {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${screen.smMin}) {
    .layout-container {
      flex-direction: row;
    }
  }

  .summary {
    margin-bottom: 10px;
  }

  @media (min-width: ${screen.smMin}) {
    .summary {
      min-width: 200px;
    }
  }

  .date {
    font-weight: 900;
  }

  .overall-rating {
    margin-top: 8px;
  }

  .overall-rating-label {
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .content {
    margin-top: 15px;
    font-weight: 300;
  }

  .content.collapsed {
    max-height: 90px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

/* istanbul ignore next */
export const showMoreButtonStyles = resolve`
  button {
    margin-top: 10px;
  }
`;
